﻿import * as Entities_Empty from '../../lib/entities/empty';
import View_DialogHelp from '../views/dialogHelp/dialogHelp';
import View_DialogWaiting from '../../lib/views/dialogWaiting/dialogWaiting';
import config from '../../common/config';
import * as Entities_CustomSetting from '../entities/customSetting';
import helper_createWebpage from '../helper/createWebpage';

var DefaultSetting = {
    check: function (app) {
        //Check CustomSetting
        this.checkCustomSetting(app);
    },
    createDefaultQRCode: function (app, view, callback_qrcode_finish) {
        var self = this;

        //TODO? bruges det mere
        //if (app.entities.collections.customQRCode.fullCollection.length == 0) {

        //    var tmpModel = new app.entities.collections.customQRCode.model();
        //    //tmpModel.attributes.id = null;
        //    tmpModel.attributes.AuthUserId = config.authUserId();
        //    tmpModel.attributes.Name = resources.X100123;
        //    tmpModel.attributes.Render = "canvas";
        //    tmpModel.attributes.EcLevel = "H";
        //    tmpModel.attributes.MinVersion = 6;
        //    tmpModel.attributes.Fill = "Rgb(0,0,0)";
        //    tmpModel.attributes.Background = "Rgb(255,255,255)";
        //    tmpModel.attributes.Text = resources.X100068;
        //    tmpModel.attributes.Size = 300;
        //    tmpModel.attributes.Radius = 0;
        //    tmpModel.attributes.Quiet = 1;
        //    tmpModel.attributes.Mode = 3;
        //    tmpModel.attributes.MSize = 11;
        //    tmpModel.attributes.MPosX = 50;
        //    tmpModel.attributes.MPosY = 50;
        //    tmpModel.attributes.Label = "Events4us";
        //    tmpModel.attributes.FontName = "Arial,Arial,Helvetica,sans-serif";
        //    tmpModel.attributes.FontColor = "Rgb(255,0,0)";
        //    tmpModel.attributes.FontStyle = 0;
        //    tmpModel.attributes.FontSize = "30px";
        //    tmpModel.attributes.Logo = "/images/Events4us.png";

        //    $('#QRCodeInsert_container').empty();

        //    var dialogWaitingModel = new Entities_Empty.Model();
        //    dialogWaitingModel.attributes.Title = resources.X100071;
        //    dialogWaitingModel.attributes.Text = resources.X100307;
        //    dialogWaitingModel.attributes.Button = resources.X100279;

        //    var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: view });
        //    var callback = function (options) {
        //        dialogWaiting.triggerMethod('dialog:close');
        //        view.stopListening(dialogWaiting, "dialog:okclicked", callback);

        //        $('.modal-backdrop').remove();
        //    }
        //    view.listenTo(dialogWaiting, "dialog:okclicked", callback);
        //    app.dialogRegion.show(dialogWaiting);

        //    $('#QRCodeInsert_qrCodeLogo').load(function () {
        //        var tmpModelQRCode = new Entities_Empty.Model();
        //        //tmpModelQRCode.attributes.id = -1;

        //        tmpModelQRCode = helper_createWebpage.createQRCodeImage(tmpModel, tmpModelQRCode, $('#QRCodeInsert_qrCodeLogo'), $('#QRCodeInsert_qrCodeContainer'), false, app);
        //        tmpModel.attributes.ImageData = tmpModelQRCode.attributes.ImageData;
        //        tmpModel.attributes.ImageMimeType = tmpModelQRCode.attributes.ImageMimeType;
        //        tmpModel.attributes.ImageUpdate = tmpModelQRCode.attributes.ImageUpdate;
        //        tmpModel.attributes.Filename = tmpModel.attributes.Name + '_' + new Date().getTime() + '.jpg';

        //        $('#QRCodeInsert_container').empty();
        //        $('#QRCodeInsert_qrCodeLogo').off("load");

        //        app.entities.collections.customQRCode.fullCollection.create(tmpModel, {
        //            success: function (response) {
        //                dialogWaiting.triggerMethod('dialog:okclicked');
        //                callback_qrcode_finish(true);
        //            },
        //            error: function (response) {
        //                callback_qrcode_finish(false);
        //            }
        //        }, app);
        //    });
        //    $('#QRCodeInsert_qrCodeLogo').attr("src", tmpModel.attributes.Logo);
        //} else {
        //    callback_qrcode_finish(true);
        //}

        callback_qrcode_finish(true);
    },

    checkCustomSetting: function (app, view, callback) {
        var self = this;
        var succes = true;

        var callback01 = function () {
            var customSetting01 = app.entities.collections.customSetting.where({ Name: 'Webeditor' });
            if (customSetting01.length == 0) {
                var tmpModel01 = new app.entities.collections.customSetting.model();
                //tmpModel.attributes.id = null;
                tmpModel01.attributes.AuthUserId = config.authUserId();
                tmpModel01.attributes.Name = 'Webeditor';
                tmpModel01.attributes.Value = '1';

                app.entities.collections.customSetting.create(tmpModel01, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback02();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback02();
                    }
                });
            } else {
                callback02();
            }
        }

        var callback02 = function () {
            var customSetting02 = app.entities.collections.customSetting.where({ Name: 'SchemaDataItemPerPage' });
            if (customSetting02.length == 0) {
                var tmpModel02 = new app.entities.collections.customSetting.model();
                tmpModel02.attributes.AuthUserId = config.authUserId();
                tmpModel02.attributes.Name = 'SchemaDataItemPerPage';
                tmpModel02.attributes.Value = '25';

                app.entities.collections.customSetting.create(tmpModel02, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback03();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback03();
                    }
                });
            } else {
                callback03();
            }
        }

        var callback03 = function () {
            var customSetting03 = app.entities.collections.customSetting.where({ Name: 'FormDataItemPerPage' });
            if (customSetting03.length == 0) {
                var tmpModel03 = new app.entities.collections.customSetting.model();
                tmpModel03.attributes.AuthUserId = config.authUserId();
                tmpModel03.attributes.Name = 'FormDataItemPerPage';
                tmpModel03.attributes.Value = '25';

                app.entities.collections.customSetting.create(tmpModel03, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback04();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback04();
                    }
                });
            } else {
                callback04();
            }
        }

        var callback04 = function () {
            var customSetting04 = app.entities.collections.customSetting.where({ Name: 'ProductSheetDataItemPerPage' });
            if (customSetting04.length == 0) {
                var tmpModel04 = new app.entities.collections.customSetting.model();
                tmpModel04.attributes.AuthUserId = config.authUserId();
                tmpModel04.attributes.Name = 'ProductSheetDataItemPerPage';
                tmpModel04.attributes.Value = '25';

                app.entities.collections.customSetting.create(tmpModel04, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback05();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback05();
                    }
                });
            } else {
                callback05();
            }
        }

        var callback05 = function () {
            var customSetting05 = app.entities.collections.customSetting.where({ Name: 'WebpageImageUrlMethod' });
            if (customSetting05.length == 0) {
                var tmpModel05 = new app.entities.collections.customSetting.model();
                tmpModel05.attributes.AuthUserId = config.authUserId();
                tmpModel05.attributes.Name = 'WebpageImageUrlMethod';
                tmpModel05.attributes.Value = '2';

                app.entities.collections.customSetting.create(tmpModel05, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback06();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback06();
                    }
                });
            } else {
                callback06();
            }
        }

        var callback06 = function () {
            var customSetting06 = app.entities.collections.customSetting.where({ Name: 'ImageOriginal' });
            if (customSetting06.length == 0) {
                var tmpModel06 = new app.entities.collections.customSetting.model();
                tmpModel06.attributes.AuthUserId = config.authUserId();
                tmpModel06.attributes.Name = 'ImageOriginal';
                tmpModel06.attributes.Value = '0';

                app.entities.collections.customSetting.create(tmpModel06, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback07();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback07();
                    }
                });
            } else {
                callback07();
            }
        }


        var callback07 = function () {
            var customSetting07 = app.entities.collections.customSetting.where({ Name: 'ImageWebOptimize500' });
            if (customSetting07.length == 0) {
                var tmpModel07 = new app.entities.collections.customSetting.model();
                tmpModel07.attributes.AuthUserId = config.authUserId();
                tmpModel07.attributes.Name = 'ImageWebOptimize500';
                tmpModel07.attributes.Value = '1';

                app.entities.collections.customSetting.create(tmpModel07, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback08();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback08();
                    }
                });
            } else {
                callback08();
            }
        }

        var callback08 = function () {
            var customSetting08 = app.entities.collections.customSetting.where({ Name: 'ImageWebOptimize1000' });
            if (customSetting08.length == 0) {
                var tmpModel08 = new app.entities.collections.customSetting.model();
                tmpModel08.attributes.AuthUserId = config.authUserId();
                tmpModel08.attributes.Name = 'ImageWebOptimize1000';
                tmpModel08.attributes.Value = '0';

                app.entities.collections.customSetting.create(tmpModel08, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback09();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback09();
                    }
                });
            } else {
                callback09();
            }
        }

        var callback09 = function () {
            var customSetting09 = app.entities.collections.customSetting.where({ Name: 'ImageWebOptimizeRound500' });
            if (customSetting09.length == 0) {
                var tmpModel09 = new app.entities.collections.customSetting.model();
                tmpModel09.attributes.AuthUserId = config.authUserId();
                tmpModel09.attributes.Name = 'ImageWebOptimizeRound500';
                tmpModel09.attributes.Value = '0';

                app.entities.collections.customSetting.create(tmpModel09, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback10();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback10();
                    }
                });
            } else {
                callback10();
            }
        }

        var callback10 = function () {
            var customSetting10 = app.entities.collections.customSetting.where({ Name: 'ImageWebOptimizeRound1000' });
            if (customSetting10.length == 0) {
                var tmpModel10 = new app.entities.collections.customSetting.model();
                tmpModel10.attributes.AuthUserId = config.authUserId();
                tmpModel10.attributes.Name = 'ImageWebOptimizeRound1000';
                tmpModel10.attributes.Value = '0';

                app.entities.collections.customSetting.create(tmpModel10, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback11();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback11();
                    }
                });
            } else {
                callback11();
            }
        }

        var callback11 = function () {
            var customSetting11 = app.entities.collections.customSetting.where({ Name: 'CustomEventViewInformation' });
            if (customSetting11.length == 0) {
                var tmpModel11 = new app.entities.collections.customSetting.model();
                tmpModel11.attributes.AuthUserId = config.authUserId();
                tmpModel11.attributes.Name = 'CustomEventViewInformation';
                tmpModel11.attributes.Value = '0';

                app.entities.collections.customSetting.create(tmpModel11, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback12();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback12();
                    }
                });
            } else {
                callback12();
            }
        }

        var callback12 = function () {
            var customSetting12 = app.entities.collections.customSetting.where({ Name: 'CustomEventViewSortByEvent' });
            if (customSetting12.length == 0) {
                var tmpModel12 = new app.entities.collections.customSetting.model();
                tmpModel12.attributes.AuthUserId = config.authUserId();
                tmpModel12.attributes.Name = 'CustomEventViewSortByEvent';
                tmpModel12.attributes.Value = '1';

                app.entities.collections.customSetting.create(tmpModel12, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        //callback(succes);
                        callback13();
                    },
                    error: function (mode, response) {
                        succes = false;
                        //callback(succes);
                        callback13();
                    }
                });
            } else {
                //callback(succes);
                callback13();
            }
        }

        var callback13 = function () {
            var customSetting13 = app.entities.collections.customSetting.where({ Name: 'ImageWebOptimizeAd' });
            if (customSetting13.length == 0) {
                var tmpModel13 = new app.entities.collections.customSetting.model();
                tmpModel13.attributes.AuthUserId = config.authUserId();
                tmpModel13.attributes.Name = 'ImageWebOptimizeAd';
                tmpModel13.attributes.Value = '0';

                app.entities.collections.customSetting.create(tmpModel13, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback14();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback14();
                    }
                });
            } else {
                callback14();
            }
        }

        var callback14 = function () {
            var customSetting14 = app.entities.collections.customSetting.where({ Name: 'ShowLink' });
            if (customSetting14.length == 0) {
                var tmpModel14 = new app.entities.collections.customSetting.model();
                tmpModel14.attributes.AuthUserId = config.authUserId();
                tmpModel14.attributes.Name = 'ShowLink';
                tmpModel14.attributes.Value = '1';

                app.entities.collections.customSetting.create(tmpModel14, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback15();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback15();
                    }
                });
            } else {
                callback15();
            }
        }

        var callback15 = function () {
            var customSetting15 = app.entities.collections.customSetting.where({ Name: 'ShowInformation' });
            if (customSetting15.length == 0) {
                var tmpModel15 = new app.entities.collections.customSetting.model();
                tmpModel15.attributes.AuthUserId = config.authUserId();
                tmpModel15.attributes.Name = 'ShowInformation';
                tmpModel15.attributes.Value = '1';

                app.entities.collections.customSetting.create(tmpModel15, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback16();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback16();
                    }
                });
            } else {
                callback16();
            }
        }

        var callback16 = function () {
            var customSetting16 = app.entities.collections.customSetting.where({ Name: 'NavigatorEvent' });
            if (customSetting16.length == 0) {
                var tmpModel16 = new app.entities.collections.customSetting.model();
                tmpModel16.attributes.AuthUserId = config.authUserId();
                tmpModel16.attributes.Name = 'NavigatorEvent';
                tmpModel16.attributes.Value = '';

                app.entities.collections.customSetting.create(tmpModel16, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback17();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback17();
                    }
                });
            } else {
                callback17();
            }
        }

        var callback17 = function () {
            var customSetting17 = app.entities.collections.customSetting.where({ Name: 'NavigatorTab' });
            if (customSetting17.length == 0) {
                var tmpModel17 = new app.entities.collections.customSetting.model();
                tmpModel17.attributes.AuthUserId = config.authUserId();
                tmpModel17.attributes.Name = 'NavigatorTab';
                tmpModel17.attributes.Value = '1';

                app.entities.collections.customSetting.create(tmpModel17, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback18();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback18();
                    }
                });
            } else {
                callback18();
            }
        }

        var callback18 = function () {
            var customSetting18 = app.entities.collections.customSetting.where({ Name: 'NavigatorMacro' });
            if (customSetting18.length == 0) {
                var tmpModel18 = new app.entities.collections.customSetting.model();
                tmpModel18.attributes.AuthUserId = config.authUserId();
                tmpModel18.attributes.Name = 'NavigatorMacro';
                tmpModel18.attributes.Value = '1';

                app.entities.collections.customSetting.create(tmpModel18, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback19();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback19();
                    }
                });
            } else {
                callback19();
            }
        }

        var callback19 = function () {
            var customSetting19 = app.entities.collections.customSetting.where({ Name: 'WebPageSetting' });
            if (customSetting19.length == 0) {
                var tmpModel19 = new app.entities.collections.customSetting.model();
                tmpModel19.attributes.AuthUserId = config.authUserId();
                tmpModel19.attributes.Name = 'WebPageSetting';
                tmpModel19.attributes.Value = '1';

                app.entities.collections.customSetting.create(tmpModel19, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback20();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback20();
                    }
                });
            } else {
                callback20();
            }
        }

        var callback20 = function () {
            var customSetting20 = app.entities.collections.customSetting.where({ Name: 'InfoPageSetting' });
            if (customSetting20.length == 0) {
                var tmpModel20 = new app.entities.collections.customSetting.model();
                tmpModel20.attributes.AuthUserId = config.authUserId();
                tmpModel20.attributes.Name = 'InfoPageSetting';
                tmpModel20.attributes.Value = '1';

                app.entities.collections.customSetting.create(tmpModel20, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback21();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback21();
                    }
                });
            } else {
                callback21();
            }
        }

        var callback21 = function () {
            var customSetting21 = app.entities.collections.customSetting.where({ Name: 'SchemaSetting' });
            if (customSetting21.length == 0) {
                var tmpModel21 = new app.entities.collections.customSetting.model();
                tmpModel21.attributes.AuthUserId = config.authUserId();
                tmpModel21.attributes.Name = 'SchemaSetting';
                tmpModel21.attributes.Value = '1';

                app.entities.collections.customSetting.create(tmpModel21, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback22();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback22();
                    }
                });
            } else {
                callback22();
            }
        }

        var callback22 = function () {
            var customSetting22 = app.entities.collections.customSetting.where({ Name: 'PosterPageSetting' });
            if (customSetting22.length == 0) {
                var tmpModel22 = new app.entities.collections.customSetting.model();
                tmpModel22.attributes.AuthUserId = config.authUserId();
                tmpModel22.attributes.Name = 'PosterPageSetting';
                tmpModel22.attributes.Value = '1';

                app.entities.collections.customSetting.create(tmpModel22, {
                    silent: true,
                    wait: true,
                    success: function (response) {
                        callback23();
                    },
                    error: function (mode, response) {
                        succes = false;
                        callback23();
                    }
                });
            } else {
                callback23();
            }
        }

        

        var callback23 = function () {
            var callback23Finish = function (succesQRCode) {
                if (succesQRCode == false) {
                    succes = false;
                }

                callback(succes);
            }

            self.createDefaultQRCode(app, view, callback23Finish)
        }

        callback01();
    },
    SetStartUp: function () {
        var customSetting19 = app.entities.collections.customSetting.where({ Name: 'WebPageSetting' });
        customSetting19[0].attributes.Value = '1';

        //var customSetting20 = app.entities.collections.customSetting.where({ Name: 'InfoPageSetting' });
        //customSetting20[0].attributes.Value = '0';
        
        //var customSetting21 = app.entities.collections.customSetting.where({ Name: 'PosterSetting' });
        //customSetting21[0].attributes.Value = '1';

        //var customSetting22 = app.entities.collections.customSetting.where({ Name: 'SchemaSetting' });
        //customSetting22[0].attributes.Value = '1';
    }

}

export default DefaultSetting;